import { i18n } from "@lingui/core";
import React from 'react';
import $switchCaseDefault from 'dolla-switch';
import { Dumb as Molecules } from '../../../molecules';
import { Tooltip } from '../../../molecules/dumb';
import { createDataLookup } from '../../../const';
import { useConfig } from '../../../../utils/config';
import { useBooleanRateLimited, useEffectOnTrueLogPaywall } from '../../../../hooks';
import { localI18n } from '../../../../i18n';
const uxCopy = {
  label: localI18n._("Require viewer name and email"),
  analyticsLabel: localI18n._("Track this link on Prezi Analytics")
};
const getTooltipUxCopy = reason => $switchCaseDefault(reason, {
  notAllowedWithCurrentLicense: () => ({
    title: i18n._("Not allowed to set Analytics"),
    body: i18n._("Track who views your presentation and which parts really pique their interest with Prezi Premium."),
    action: i18n._("Upgrade")
  })
}, () => {
  throw `Invalid component state: ${reason}`;
});
export const ToggleRequireEmail = ({
  checked,
  controlContext,
  handleOnChange
}) => {
  const toggleRef = React.useRef(null);
  const [isTooltipOpen, setIsTooltipOpen] = useBooleanRateLimited();
  const {
    onUpgrade
  } = useConfig();
  useEffectOnTrueLogPaywall(isTooltipOpen, controlContext.paywall);
  return React.createElement("div", null, React.createElement(Molecules.ToggleSimple, {
    id: "trackable-view-link-require-email",
    handleOnChange: handleOnChange,
    label: uxCopy.label,
    checked: checked,
    disabled: controlContext.disabled,
    triggerRef: toggleRef,
    setTooltipOpen: setIsTooltipOpen,
    dataLookup: createDataLookup('require-email-toggle')
  }), controlContext.paywall && React.createElement(Tooltip, {
    uxCopy: getTooltipUxCopy(controlContext.paywall.reason),
    onAction: () => onUpgrade('pitch_analytics'),
    isOpen: isTooltipOpen,
    triggerRef: toggleRef
  }));
};
export const ToggleAnalytics = ({
  checked,
  controlContext,
  handleOnChange
}) => {
  const {
    onUpgrade
  } = useConfig();
  const toggleRef = React.useRef(null);
  const [isTooltipOpen, setIsTooltipOpen] = useBooleanRateLimited();
  useEffectOnTrueLogPaywall(isTooltipOpen, controlContext.paywall);
  return React.createElement(React.Fragment, null, React.createElement(Molecules.ToggleSimple, {
    id: "trackable-view-link-analytics",
    handleOnChange: handleOnChange,
    label: uxCopy.analyticsLabel,
    checked: checked,
    disabled: controlContext.disabled,
    triggerRef: toggleRef,
    setTooltipOpen: setIsTooltipOpen,
    dataLookup: createDataLookup('enable-analytics-toggle')
  }), controlContext.paywall && React.createElement(Tooltip, {
    uxCopy: getTooltipUxCopy(controlContext.paywall.reason),
    onAction: () => onUpgrade('pitch_analytics'),
    isOpen: isTooltipOpen,
    triggerRef: toggleRef
  }));
};